

export const googleCalendarConfig = {
  apiKey: 'AIzaSyDrmHKkqiwgQuyAWNUXQzBKq9ud2XaqXDY',
  clientId: 'YOUR_CLIENT_ID',
  discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
  scopes: 'https://www.googleapis.com/auth/calendar'
};